import React, { useLayoutEffect, useState } from 'react';
import styled from 'styled-components';
import { graphql } from 'gatsby';
import Modal from 'react-modal';
import TrackVisibility from 'react-on-screen';
import { Logo as PartnerLogo } from '../components/Partners';

import { WrappedMenu } from '../components/new/Menu';
import { Footer } from '../components/new/Footer';
import { PromoVideo } from '../components/new/PromoVideo';
import { ModalSignup } from '../components/new/ModalSignup';
import { TeachingSlider } from '../components/TeachingSlider';
import { BlogCardsComponent } from '../components/new/BlogCardsComponent';
import { ReviewsSlider } from '../components/ReviewsSlider';
import { SEO } from '../components/seo';
import { PrimaryButton } from '../components/new/Pages';

import whiteWaveBg from '../images/main/white-wave.svg';

import dms from '../images/partners-logo/dms.png';
import grape from '../images/partners-logo/grape.png';
import hungry from '../images/partners-logo/hungry.png';
import possible from '../images/partners-logo/possible.png';
import traektoria from '../images/partners-logo/traektoria.png';
import magicpiano from '../images/partners-logo/magic-piano.png';
import adconsult from '../images/partners-logo/adconsult.png';
import startrocket from '../images/partners-logo/start-rocket.png';
import mads from '../images/partners-logo/mads.png';

import ogImage from '../images/og-image.jpg';

import videoBlob from '../images/video-blob.png';

import kespaDesktop from '../images/kespa-desktop.mp4';
import kespaMobile from '../images/kespa-mobile.mp4';
import { Wrap } from '../components/new/Wrap';
import { Container } from '../components/Container';

// const MenuWrap = styled.div`
//     margin-top: 16px;
//     display: flex;
//     align-items: flex-start;
// `;

const H1 = styled.h1`
    font-family: 'Futura PT', sans-serif;
    font-weight: 700;
    font-size: 98px;
    line-height: 100%;
    color: #000;

    @media screen and (max-width: 1024px) {
        font-size: 70px;
    }

    @media screen and (max-width: 760px) {
        font-size: 50px;
    }
`;

const H2 = styled.h2`
    font-family: 'Futura PT', sans-serif;
    font-weight: 700;
    font-size: 70px;
    line-height: 100%;
    color: #000;

    @media screen and (max-width: 1366px) {
        font-size: 48px;
    }

    @media screen and (max-width: 760px) {
        font-size: 28px;
    }
`;

const H3 = styled.h3`
    font-family: 'Futura PT', sans-serif;
    font-weight: 700;
    font-size: ${props => (props.fontSize ? props.fontSize : '48')}px;
    line-height: 100%;
    color: #000000;

    @media screen and (max-width: 1366px) {
        font-size: 38px;
    }

    @media screen and (max-width: 760px) {
        font-size: 28px;
    }
`;

const CondensedText = styled.div`
    font-family: 'Futura PT', sans-serif;
    font-weight: 700;
    font-size: 48px;
    line-height: 100%;
    color: #000;
    margin: 24px 0 0;
    text-indent: -1px;

    @media screen and (max-width: 1200px) {
        font-size: 40px;
    }

    @media screen and (max-width: 1024px) {
        font-size: 28px;
    }

    @media screen and (max-width: 768px) {
        font-size: 22px;
    }
`;

const SectionMessage = styled.div`
    font-family: 'Circe Web', sans-serif;
    font-weight: normal;
    font-size: 22px;
    line-height: 140%;
    color: #404040;
    margin: 40px 0 0;

    p {
        & + p {
            margin-top: 24px;
        }
    }

    @media screen and (max-width: 1024px) {
        margin: 24px 0 0;
        font-size: 18px;
        line-height: 150%;
        p {
            & + p {
                margin-top: 16px;
            }
        }
    }

    @media screen and (max-width: 760px) {
        margin: 16px 0 0;
        font-size: 14px;
        line-height: 150%;
    }
`;

const SectionWrapper = styled.div`
    position: relative;
    width: 100%;

    &.faded-btm,
    &.faded-top {
        background-repeat: repeat-x;
        background-position: 50% 100%;
    }

    &.faded-btm {
        background-image: linear-gradient(
            180deg,
            rgba(196, 196, 196, 0) 0%,
            rgba(230, 230, 230, 0) 0.01%,
            #e6e6e6 100%
        );
    }

    &.faded-top {
        background-image: linear-gradient(
            180deg,
            #e6e6e6 0%,
            #e6e6e6 64.06%,
            rgba(230, 230, 230, 0) 80.21%
        );
    }

    &.white-wave-top:before,
    &.white-wave-btm:after {
        content: '';
        position: absolute;
        left: 0;
        width: 100%;
        height: 170px;
        display: block;
        background-repeat: repeat-x;
        background-position: 50% 0;
        background-size: cover;

        @media screen and (max-width: 760px) {
            height: 70px;
        }
    }

    &.white-wave-top {
        padding-top: 122px;
        box-sizing: border-box;

        &:before {
            top: -1px;
            background-image: url(${whiteWaveBg});
            transform: scaleY(-1);
        }

        @media screen and (max-width: 760px) {
            padding-top: 70px;
        }
    }

    &.white-wave-btm {
        padding-bottom: 122px;
        box-sizing: border-box;

        &:after {
            bottom: -1px;
            background-image: url(${whiteWaveBg});
        }

        @media screen and (max-width: 760px) {
            padding-bottom: 70px;
        }
    }

    &.blue {
        background-color: #0dbdfc;
    }

    &.platform {
        @media screen and (max-width: 1200px) {
            overflow-x: hidden;
        }
    }
`;

const Section = styled.div`
    position: relative;
    max-width: 1360px;
    min-width: 320px;
    padding: 0 24px;
    margin: 0 auto;
    box-sizing: border-box;

    &.slider-section {
        padding: 0;

        h3 {
            padding: 0 24px;
            box-sizing: border-box;
        }
    }

    .main-block {
        padding: 135px 0 130px;
        box-sizing: border-box;
        position: relative;

        @media screen and (max-width: 1024px) {
            padding: 130px 0 80px;
            background: none;
        }

        @media screen and (max-width: 760px) {
            padding: 60px 0 90px;
            background: none;
        }
    }

    .main-block__content {
        max-width: 640px;
        text-align: center;
        position: absolute;
        left: 50%;
        top: 60px;
        transform: translateX(-50%);
        z-index: 100;

        @media screen and (max-width: 1024px) {
            max-width: 480px;
        }

        @media screen and (max-width: 760px) {
            max-width: 100%;
            position: relative;
            top: 0;
            left: 0;
            transform: translateX(0);
        }
    }

    .main-block__images {
        position: relative;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        @media screen and (max-width: 760px) {
            position: absolute;
            top: 200px;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
        }
    }

    .main-block__image-item {
        & + .main-block__image-item {
            margin-left: 200px;

            @media screen and (max-width: 760px) {
                margin-left: 0;
            }
        }
    }

    .main-block__student-desktop,
    .main-block__teacher-desktop {
        display: block;
        width: 528px;
        max-width: 100%;
        height: auto;

        @media screen and (max-width: 760px) {
            display: none;
        }
    }

    .main-block__student-mobile,
    .main-block__teacher-mobile {
        display: none;

        @media screen and (max-width: 760px) {
            display: block;
            max-width: 100%;
            height: auto;
        }
    }

    .main-block__student-mobile {
        @media screen and (max-width: 760px) {
            width: 174px;
            margin-top: 92px;
        }
    }

    .main-block__teacher-mobile {
        @media screen and (max-width: 760px) {
            margin-top: 10px;
            width: 167px;
        }
    }

    .training-block {
        padding: 197px 0 0;
        box-sizing: border-box;
        display: flex;
        align-items: flex-start;
        margin-bottom: 197px;

        @media screen and (max-width: 1024px) {
            padding: 148px 0 0;
            margin-bottom: 140px;
        }
        @media screen and (max-width: 760px) {
            padding: 64px 0 87px;
            background: none;
            display: block;
            margin-bottom: 0;
        }
    }

    .training-block__content {
        width: 560px;
        margin-right: 32px;

        @media screen and (max-width: 760px) {
            max-width: 100%;
        }
    }

    .training-block__image {
        width: 640px;
        margin-left: auto;
        text-align: right;

        @media screen and (max-width: 1024px) {
            width: 560px;
        }

        @media screen and (max-width: 760px) {
            width: 100%;
            margin: 57px auto 0;
        }
    }

    .training-block__image-desktop {
        @media screen and (max-width: 760px) {
            display: none;
        }
    }

    .training-block__image-mobile {
        display: none;

        @media screen and (max-width: 760px) {
            display: block;
        }
    }

    .teachers-block {
        min-height: 720px;
        display: flex;

        .teachers-block__cta_mobile {
            display: none;
        }
        s .teachers-block__cta_desktop {
            display: block;
        }

        @media screen and (max-width: 760px) {
            display: flex;
            flex-direction: column;
            min-height: 0;
            padding-bottom: 64px;

            .teachers-block__cta_mobile {
                display: block;
            }

            .teachers-block__cta_desktop {
                display: none;
            }
        }
    }

    .teachers-block__content {
        max-width: 40%;
        margin-right: 32px;

        small {
            font-size: 14px;
            line-height: 140%;
            display: inline-block;
        }

        @media screen and (max-width: 760px) {
            width: 100%;
            max-width: 100%;
            margin-right: 0;
        }
    }

    .posts-block {
        padding: 64px 0 0;
        box-sizing: border-box;
    }

    .responses-block {
        padding: 120px 0 0;
        box-sizing: border-box;

        @media screen and (max-width: 1024px) {
            padding: 80px 0 0;
        }
        @media screen and (max-width: 760px) {
            padding: 64px 0 0;
        }

        &__content {
            overflow-x: hidden;
        }
    }

    .price-block {
        padding: 90px 0 100px;
        box-sizing: border-box;
        position: relative;

        h3 {
            color: #fff;
        }

        @media screen and (max-width: 760px) {
            padding: 64px 0 100px;
        }
    }

    .price-list {
        display: flex;
        align-items: flex-start;
        width: 100%;
        padding: 124px 0 0;
        box-sizing: border-box;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: stretch;

        @media screen and (max-width: 1024px) {
            padding: 90px 0 0;
            align-items: flex-start;
        }

        @media screen and (max-width: 720px) {
            padding: 124px 0 0;
        }
    }

    .price-list__item {
        width: 32%;
        min-width: calc(320px - 24px);
        max-width: 416px;
        background: #fff;
        box-shadow: 10px 15px 50px -5px rgba(0, 0, 0, 0.15);
        border-radius: 16px;
        padding: 0 40px 32px 32px;
        box-sizing: border-box;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        position: relative;

        @media screen and (max-width: 1024px) {
            padding: 24px;
            width: 100%;
            max-width: 100%;
            flex-direction: row;

            & + .price-list__item {
                margin: 32px 0 0;
            }

            &:last-child {
                margin-bottom: 60px;
            }
        }

        @media screen and (max-width: 760px) {
            flex-direction: column;
            padding: 0 40px 32px 32px;

            & + .price-list__item {
                margin: 145px 0 0;
            }
        }
    }

    .price-list__item-content {
        display: flex;
        flex-direction: column;
        flex: 1;
        align-items: flex-start;
    }

    .price-list__image-wrapper {
        height: 140px;
        display: flex;
        align-self: center;
        align-items: flex-end;
        margin: 0 0 42px;
        position: relative;

        @media screen and (max-width: 1024px) {
            margin: 0 24px 0 0;
            align-items: center;
            min-width: 140px;
            width: 256px;
        }

        @media screen and (max-width: 760px) {
            margin: 0 0 42px;
            align-items: flex-end;
        }
    }

    .price-list__image {
        display: block;
        max-width: 100%;
        height: auto;
    }

    .price-list__item-title {
        font-family: 'Futura PT', sans-serif;
        font-weight: 700;
        font-size: 36px;
        line-height: 100%;
        color: #000;

        @media screen and (max-width: 1024px) {
            font-size: 24px;
        }
    }

    .price-list__item-amount {
        margin-top: 16px;
        display: flex;
        align-items: flex-end;
    }

    .price-list__amount-count {
        font-family: 'Circe Web', sans-serif;
        font-size: 44px;
        line-height: 100%;
        color: #000;

        @media screen and (max-width: 1024px) {
            font-size: 36px;
        }
    }

    .price-list__amount-period {
        font-family: 'Circe Web', sans-serif;
        font-size: 18px;
        line-height: 140%;
        color: #404040;
        margin: 0 8px;

        @media screen and (max-width: 1024px) {
            font-size: 16px;
        }
    }

    .price-list__item-description {
        font-family: 'Circe Web', sans-serif;
        font-size: 18px;
        line-height: 140%;
        color: #000;
        margin: 24px 0;
    }

    .price-list__item-button {
        margin-top: auto;
    }

    .teachers {
        position: relative;
        width: 100%;
        margin-left: auto;
        list-style: none;

        @media screen and (max-width: 760px) {
            margin-top: 24px;
            height: 40vw;
            width: 100%;
            display: block;
        }
    }

    .teachers__item {
        position: absolute;
    }

    .teachers__item_1 {
        top: 50%;
        left: 8%;
        width: 34%;

        span {
            width: 187px;
            left: 117px;
        }

        img {
            width: 55%;
        }

        @media screen and (max-width: 1024px) {
            top: 47%;
            left: 5%;
            span {
                width: 170px;
                left: 95px;
            }
        }
        @media screen and (max-width: 920px) {
            span {
                width: 150px;
                left: 90px;
            }
            img {
                width: 75%;
            }
        }
        @media screen and (max-width: 760px) {
            top: auto;
            bottom: 0;
            left: 18%;
            width: 20%;
            img {
                width: 100%;
            }
        }
    }

    .teachers__item_2 {
        top: 29%;
        right: 0;
        width: 50%;

        span {
            width: 202px;
            left: 157px;
            top: 14px;
        }

        img {
            width: 47%;
        }

        @media screen and (max-width: 1024px) {
            top: 26%;
            right: 7%;
            span {
                width: 165px;
                left: 110px;
                top: 10px;
            }
        }
        @media screen and (max-width: 920px) {
            right: 20%;
            span {
                width: 150px;
                left: 100px;
                top: 5px;
            }
            img {
                width: 60%;
            }
        }
        @media screen and (max-width: 760px) {
            top: 0;
            left: 0;
            right: auto;
            width: 20%;
            img {
                width: 100%;
            }
        }
    }

    .teachers__item_3 {
        top: -5%;
        right: auto;
        width: 90%;

        span {
            width: 356px;
            left: 283px;
        }

        img {
            width: 47%;
        }

        @media screen and (max-width: 1024px) {
            top: -5%;
            span {
                width: 300px;
                left: 200px;
            }
        }
        @media screen and (max-width: 920px) {
            left: -5%;
            span {
                width: 240px;
                left: 170px;
            }
            img {
                width: 60%;
            }
        }
        @media screen and (max-width: 760px) {
            top: 0;
            right: 25%;
            width: 35%;
            left: initial;
            img {
                width: 100%;
            }
        }
    }

    .teachers__item_4 {
        right: 10%;
        bottom: 0%;
        width: 60%;

        span {
            width: 254px;
            left: 188px;
            top: 16px;
        }

        img {
            width: 50%;
        }

        @media screen and (max-width: 1024px) {
            right: 20%;
            bottom: 12%;
            span {
                width: 195px;
                left: 160px;
                top: 15px;
            }
        }
        @media screen and (max-width: 920px) {
            span {
                width: 185px;
                left: 140px;
                top: 15px;
            }
            img {
                width: 70%;
            }
        }
        @media screen and (max-width: 760px) {
            right: 0;
            bottom: 0;
            width: 20%;
            img {
                width: 100%;
            }
        }
    }

    .teachers__item_1,
    .teachers__item_2,
    .teachers__item_3,
    .teachers__item_4 {
        @media screen and (max-width: 760px) {
            .teachers__item-text {
                display: none;
            }
        }
    }

    .teachers__item-text {
        position: absolute;
        left: 100%;
        z-index: 10;
        background: #fff;
        box-shadow: 10px 15px 50px -5px rgba(0, 0, 0, 0.15);
        border-radius: 16px;
        padding: 8px 16px 12px;
        box-sizing: border-box;
        font-family: 'Circe Web', sans-serif;
        font-size: 18px;
        line-height: 140%;

        @media screen and (max-width: 1024px) {
            font-size: 14px;
        }
        @media screen and (max-width: 920px) {
            font-size: 12px;
        }
    }

    .teachers__item-text_big {
        padding: 16px 24px 24px;
    }
`;
// const BlogPostsCards = styled.div`
//     display: flex;
//     align-items: flex-start;
//     width: 100%;
//     justify-content: space-between;
//     flex-wrap: wrap;
//     padding: 48px 0 0;

//     @media screen and (max-width: 760px) {
//         padding: 40px 0 0;
//     }

//     .blog-posts__card-wrapper {
//         max-width: 417px;
//         width: 30%;
//         min-width: 320px;

//         @media screen and (max-width: 1024px) {
//             width: 31%;
//             min-width: 280px;
//         }
//         @media screen and (max-width: 920px) {
//             max-width: 100%;
//             width: 48%;
//             margin-bottom: 32px;
//             &:last-child {
//                 display: none;
//             }
//         }

//         @media screen and (max-width: 760px) {
//             max-width: 100%;
//             width: 100%;
//             &:last-child {
//                 display: block;
//             }
//         }
//     }
// `;

const StyledPartners = styled.div`
    margin-top: 144px;
    @media screen and (max-width: 760px) {
        margin-top: 120px;
    }
`;

const StyledPartnersLogos = styled.div`
    margin-top: 64px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    align-items: center;

    @media screen and (max-width: 1024px) {
        margin-top: 48px;
    }

    @media screen and (max-width: 760px) {
        margin-bottom: 24px;
    }
`;

const StyledVideoContainer = styled.div`
    position: relative;
    width: 100%;
    text-align: center;
`;

const StyledVideo = styled.video`
    border-radius: 8px;
    max-width: 640px;
    box-shadow: 10px 15px 50px -5px rgba(0, 0, 0, 0.15);

    @media screen and (max-width: 760px) {
        max-width: 80%;
        border-radius: 16px;
        margin: 0 auto;
    }
`;

const StyledVideoBlob = styled.img`
    position: absolute;
    top: -40%;
    left: -10%;
    z-index: -1;
    width: 120%;

    @media screen and (max-width: 1024px) {
        top: -30%;
    }
    @media screen and (max-width: 760px) {
        top: -10%;
        left: -15%;
        width: 130%;
    }
`;

const partnersLogo = [
    {
        name: possible,
        link: 'https://www.possiblegroup.ru/',
    },
    {
        name: grape,
        link: 'http://grape.ru/',
    },
    {
        name: hungry,
        link: 'https://hungryboys.ru/',
    },
    {
        name: dms,
        link: 'https://disrupt.moscow/',
    },
    {
        name: startrocket,
        link: 'https://startrocket.me/',
    },
    {
        name: traektoria,
        link: 'https://www.traektoriafdn.ru/',
    },
    {
        name: magicpiano,
        link: 'https://volshebnoe-pianino.ru/',
    },
    {
        name: mads,
        link: 'https://madscourses.ru/',
    },
    {
        name: adconsult,
        link: 'https://adconsult.ru/',
    },
];

Modal.defaultStyles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 999,
        backgroundColor: 'rgba(255,255,255, 0.9)',
    },
    content: {},
};

// const StyledModalBody = styled.div`
//     padding: 40px;
//     width: 380px;
//     max-width: 90vw;
//     position: relative;
// `;

// const StyledModalClose = styled.div`
//     position: absolute;
//     right: 8px;
//     top: 8px;
//     height: 40px;
//     width: 40px;
//     opacity: 0.2;
//     cursor: pointer;
//     &:hover {
//         opacity: 1;
//     }
//     svg {
//         height: 40px;
//         width: 40px;
//     }
// `;

const MainPage = ({ data }) => {
    const [modalOpen, setModalOpen] = useState(null);

    const closeModal = () => {
        setModalOpen(null);
    };

    useLayoutEffect(() => {
        if (modalOpen !== null) {
            document.body.style.overflow = 'hidden';
            return () => {
                document.body.style.overflow = 'unset';
            };
        }
    }, [modalOpen]);

    const { nodes: posts } = data.allMarkdownRemark;
    return (
        <React.Fragment>
            <SEO ogImage={ogImage} />
            <Wrap>
                <Container>
                    <WrappedMenu />
                </Container>

                <SectionWrapper className="faded-btm white-wave-btm">
                    <Section>
                        <div className="main-block">
                            <div className="main-block__content">
                                <H1 as="h1">КЭСПА</H1>
                                <CondensedText>
                                    Онлайн-школа английского <br /> языка
                                    с&nbsp;работающей методикой
                                </CondensedText>
                                <PrimaryButton
                                    onClick={() => setModalOpen('showSignup')}
                                    className="main-block__button"
                                >
                                    Записаться на вводный урок
                                </PrimaryButton>
                            </div>

                            <div className="main-block__images">
                                <div className="main-block__image-item">
                                    <img
                                        src="/images/main/student.svg"
                                        className="main-block__student-desktop"
                                    />
                                    <img
                                        src="/images/main/student_M.svg"
                                        className="main-block__student-mobile"
                                    />
                                </div>
                                <div className="main-block__image-item">
                                    <img
                                        src="/images/main/teacher.svg"
                                        className="main-block__teacher-desktop"
                                    />
                                    <img
                                        src="/images/main/teacher_M.svg"
                                        className="main-block__teacher-mobile"
                                    />
                                </div>
                            </div>
                        </div>
                    </Section>
                </SectionWrapper>

                <SectionWrapper>
                    <Section>
                        <TrackVisibility once partialVisibility>
                            <TeachingSlider />
                        </TrackVisibility>
                    </Section>
                </SectionWrapper>

                <SectionWrapper>
                    <Section>
                        <div className="teachers-block">
                            <div className="teachers-block__content">
                                <H2 className="c__title" id="teachers">
                                    Как начать обучение?
                                </H2>
                                <SectionMessage>
                                    <p>
                                        Вводное занятие бесплатное
                                        не&nbsp;просто так. Мы&nbsp;знаем, как
                                        важно найти &laquo;своего&raquo;
                                        преподавателя, с&nbsp;которым вам будет
                                        комфортно общаться в&nbsp;привычном для
                                        вас темпе.
                                    </p>
                                    <p>
                                        Поэтому нам важно узнать, чем
                                        вы&nbsp;интересуетесь, каков ваш уровень
                                        знания английского сейчас и&nbsp;какие
                                        цели в&nbsp;обучении вы&nbsp;перед собой
                                        ставите. А&nbsp;вы&nbsp;узнаете
                                        подробно, как мы&nbsp;учим :)
                                    </p>
                                    <div className="teachers-block__cta_desktop">
                                        <p>
                                            <PrimaryButton
                                                onClick={() =>
                                                    setModalOpen('showSignup')
                                                }
                                                className="teachers-block__button"
                                            >
                                                Записаться на вводный урок
                                            </PrimaryButton>
                                        </p>
                                        <small>
                                            вводный урок проходит
                                            на&nbsp;русском языке, а&nbsp;значит
                                            вам не&nbsp;стоит беспокоиться
                                            о&nbsp;том, что вас будут
                                            спрашивать&nbsp;то, чего
                                            вы&nbsp;пока еще не&nbsp;знаетe
                                        </small>
                                    </div>
                                </SectionMessage>
                            </div>
                            <ul className="teachers">
                                <li className="teachers__item teachers__item_1">
                                    <span className="teachers__item-text">
                                        Говорю много и простыми словами
                                    </span>
                                    <img src="/images/main/teachers/teacher1.png" />
                                </li>
                                <li className="teachers__item teachers__item_2">
                                    <span className="teachers__item-text">
                                        Быстро и красиво говорю. Но немного.
                                    </span>
                                    <img src="/images/main/teachers/teacher2.png" />
                                </li>
                                <li className="teachers__item teachers__item_3">
                                    <span className="teachers__item-text teachers__item-text_big">
                                        Научить говорить по-английски можно всех
                                        – даже тех, кто считает себя с рождения
                                        неспособным к языкам. Надо лишь
                                        учитывать личностные особенности каждого
                                        конкретного ученика.
                                    </span>
                                    <img src="/images/main/teachers/teacher3.png" />
                                </li>
                                <li className="teachers__item teachers__item_4">
                                    <span className="teachers__item-text">
                                        Предпочитаю сложные и красивые обороты в
                                        речи
                                    </span>
                                    <img src="/images/main/teachers/teacher5.png" />
                                </li>
                            </ul>

                            <div className="teachers-block__cta_mobile">
                                <p>
                                    <PrimaryButton
                                        onClick={() =>
                                            setModalOpen('showSignup')
                                        }
                                        className="teachers-block__button"
                                    >
                                        Записаться на вводный урок
                                    </PrimaryButton>
                                </p>
                                <small>
                                    вводный урок проходит на&nbsp;русском языке,
                                    а&nbsp;значит вам не&nbsp;стоит беспокоиться
                                    о&nbsp;том, что вас будут
                                    спрашивать&nbsp;то, чего вы&nbsp;пока еще
                                    не&nbsp;знаетe
                                </small>
                            </div>
                        </div>
                    </Section>
                </SectionWrapper>

                <SectionWrapper className="platform">
                    <Section>
                        <div className="training-block">
                            <div className="training-block__content">
                                <H2>Как проходит обучение?</H2>
                                <SectionMessage>
                                    <p>
                                        Вам не&nbsp;нужно покупать учебники или
                                        распечатывать материалы. Все необходимое
                                        всегда под рукой на&nbsp;вашем
                                        устройстве. Все занятия проводятся
                                        в&nbsp;индивидуальном формате.
                                        Персональная программа&nbsp;&mdash; один
                                        из&nbsp;принципов методики КЭСПА.
                                    </p>
                                </SectionMessage>
                            </div>

                            <div className="training-block__image">
                                <div className="training-block__screen-bg">
                                    <div className="training-block__image-desktop">
                                        <StyledVideoContainer>
                                            <StyledVideo
                                                autoPlay
                                                loop
                                                muted
                                                playsInline
                                            >
                                                <source
                                                    src={kespaDesktop}
                                                    type="video/mp4"
                                                />
                                            </StyledVideo>
                                            <StyledVideoBlob src={videoBlob} />
                                        </StyledVideoContainer>
                                    </div>
                                    <div className="training-block__image-mobile">
                                        <StyledVideoContainer>
                                            <StyledVideo
                                                autoPlay
                                                loop
                                                muted
                                                playsInline
                                            >
                                                <source
                                                    src={kespaMobile}
                                                    type="video/mp4"
                                                />
                                            </StyledVideo>
                                            <StyledVideoBlob src={videoBlob} />
                                        </StyledVideoContainer>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Section>
                </SectionWrapper>

                <SectionWrapper>
                    <Section>
                        <PromoVideo youtubeID="6pXCQvfUPx4">
                            <H3 as="h3" fontSize="40">
                                О стереотипах в изучении английского
                            </H3>
                            <SectionMessage>
                                <p>
                                    Видео с автором методики
                                    <br />
                                    Инной Гивенталь
                                </p>
                            </SectionMessage>
                        </PromoVideo>
                    </Section>
                </SectionWrapper>

                <SectionWrapper className="white-wave-top white-wave-btm blue">
                    <Section>
                        <div className="price-block">
                            <H3 id="price">Цены и тарифы</H3>
                            <div className="price-list">
                                <div className="price-list__item">
                                    <div className="price-list__image-wrapper">
                                        <img
                                            src="/images/main/price/price_1.svg"
                                            width="256"
                                            className="price-list__image"
                                        />
                                    </div>

                                    <div className="price-list__item-content">
                                        <div className="price-list__item-title">
                                            Индивидуальные занятия
                                        </div>

                                        <div className="price-list__item-amount">
                                            <span className="price-list__amount-period">
                                                от
                                            </span>
                                            <span className="price-list__amount-count">
                                                1375₽
                                            </span>
                                            <span className="price-list__amount-period">
                                                за занятие
                                            </span>
                                        </div>

                                        <div className="price-list__item-description">
                                            <p>
                                                Для тех, у&nbsp;кого
                                                наполеоновские планы.
                                            </p>

                                            <p>
                                                Преподаватель выявляет ваши
                                                слабые места, составляет
                                                персональную учебную программу,
                                                проверяет домашние задания.
                                                Расписание занятий составляется
                                                так, как удобно вам. Один урок
                                                длится 50&nbsp;минут.
                                            </p>
                                        </div>

                                        <PrimaryButton
                                            onClick={() =>
                                                setModalOpen('showSignup')
                                            }
                                            className="price-list__item-button"
                                        >
                                            Записаться на вводный урок
                                        </PrimaryButton>
                                    </div>
                                </div>

                                <div className="price-list__item price-list__item_two">
                                    <div
                                        className="price-list__image-wrapper"
                                        style={{ left: '20px' }}
                                    >
                                        <img
                                            src="/images/main/price/price_2.svg"
                                            width="220"
                                            className="price-list__image"
                                        />
                                    </div>

                                    <div className="price-list__item-content">
                                        <div className="price-list__item-title">
                                            Подписка на английский
                                        </div>

                                        <div className="price-list__item-amount">
                                            <span className="price-list__amount-count">
                                                3600₽
                                            </span>
                                            <span className="price-list__amount-period">
                                                в месяц
                                            </span>
                                        </div>

                                        <div className="price-list__item-description">
                                            <p>Для тех, кто всё сам.</p>

                                            <p>
                                                Вы&nbsp;получаете полный доступ
                                                к&nbsp;платформе со&nbsp;всеми
                                                уроками и&nbsp;материалами
                                                и&nbsp;самостоятельно планируете
                                                свое обучение. Раз в&nbsp;неделю
                                                преподаватель проверяет домашние
                                                задания и&nbsp;контролирует ваш
                                                прогресс.
                                            </p>
                                        </div>

                                        <PrimaryButton
                                            onClick={() =>
                                                setModalOpen('showSignup')
                                            }
                                            className="price-list__item-button"
                                        >
                                            Записаться на вводный урок
                                        </PrimaryButton>
                                    </div>
                                </div>

                                <div className="price-list__item price-list__item_three">
                                    <div className="price-list__image-wrapper">
                                        <img
                                            src="/images/main/price/price_3.svg"
                                            width="256"
                                            className="price-list__image"
                                        />
                                    </div>
                                    <div className="price-list__item-content">
                                        <div className="price-list__item-title">
                                            Специальные условия
                                        </div>

                                        <div className="price-list__item-description">
                                            Если вы&nbsp;не&nbsp;нашли
                                            подходящий тариф, или у&nbsp;вас
                                            есть промокод на&nbsp;скидку,
                                            оставьте заявку на&nbsp;бесплатное
                                            вводное занятие,
                                            и&nbsp;мы&nbsp;обсудим возможные
                                            варианты обучения специально для
                                            вас.
                                        </div>

                                        <PrimaryButton
                                            onClick={() =>
                                                setModalOpen(
                                                    'showSignupWithBio'
                                                )
                                            }
                                            className="price-list__item-button"
                                        >
                                            Написать нам
                                        </PrimaryButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Section>
                </SectionWrapper>

                <SectionWrapper>
                    <Section className="slider-section">
                        <div className="responses-block">
                            <div className="responses-block__content">
                                <H3>Нам говорят спасибо</H3>
                                <ReviewsSlider />
                            </div>
                        </div>
                    </Section>
                </SectionWrapper>

                <SectionWrapper className="faded-top white-wave-top">
                    <Section>
                        <div className="posts-block">
                            <div className="posts-block__content">
                                <H3>Блог</H3>
                                <BlogCardsComponent postsArray={posts} />
                            </div>
                        </div>
                    </Section>
                </SectionWrapper>

                <SectionWrapper>
                    <Section>
                        <StyledPartners>
                            <H3>С нами работают</H3>
                            <StyledPartnersLogos>
                                {partnersLogo.map(({ name, link }) => {
                                    return (
                                        <PartnerLogo
                                            key={name}
                                            target="_blank"
                                            href={link}
                                        >
                                            <img src={name} alt="name" />
                                        </PartnerLogo>
                                    );
                                })}
                            </StyledPartnersLogos>
                        </StyledPartners>
                    </Section>
                </SectionWrapper>

                <Footer />
            </Wrap>

            <ModalSignup
                closeTimeoutMS={700}
                onRequestClose={closeModal}
                isOpen={
                    modalOpen === 'showSignup' ||
                    modalOpen === 'showSignupWithBio'
                }
                showBio={modalOpen === 'showSignupWithBio'}
            />
        </React.Fragment>
    );
};

export default MainPage;

export const query = graphql`
    query ThreePosts {
        allMarkdownRemark(
            limit: 3
            sort: { fields: frontmatter___date, order: DESC }
        ) {
            nodes {
                cloudImage {
                    fluid(
                        transformations: [
                            "ar_5:2"
                            "c_fill"
                            "g_auto"
                            "f_auto"
                        ]
                    ) {
                        ...CloudinaryAssetFluid
                    }
                }
                frontmatter {
                    url
                    title
                    date
                }
                id
            }
        }
    }
`;
